import { authenticationRequired } from "@/authentication";
import { adminRoutes } from "@/dynamic.routes";

export default [
    {
        path: "/admin/asociar",
        name: "asociate",
        component: () => import("@/views/admin/Asociate.vue"),
        beforeEnter: adminRoutes
    },{
        path: "/crear-empresa",
        name: "create-business",
        component: () => import("@/views/factoring/NewCreateBusiness.vue"),
        beforeEnter: authenticationRequired
    },
]